import { useEffect, type ReactNode } from 'react'
import { markHydrated } from '@/lib/earlyClicks'
import { restoreEarlyInputs } from '@/lib/earlyInputs'

/**
 * Wraps the whole app: once React has taken over the server-rendered page it gives back what was typed before then
 * (lib/earlyInputs.ts), marks the page live and replays any click held meanwhile (lib/earlyClicks.ts) — in that order,
 * so a held click acts on the typed values. Lives outside the entry file, which must not define components (Vite's
 * React refresh would re-run the entry and mount the root twice).
 */
export function Hydrated({ children }: { children: ReactNode }) {
  useEffect(() => {
    restoreEarlyInputs()
    markHydrated()
  }, [])
  return children
}
